export const RECENTES = 'RECENTES';
export const LIDAS = 'LIDAS';
